import React, { useEffect, useState } from 'react';
import { LatestReviewPost } from '../../queries/contentPage/postDetail';
import {
  LatestProjectReviewButton,
  LatestProjectReviewDescription,
  LatestProjectReviewDetail,
  LatestProjectReviewFooter,
  LatestProjectReviewFooterContainer,
  LatestProjectReviewTitle,
} from './LatestProjectReviewFooter.style';

export const LatestProjectFooter = (
  props: LatestReviewPost | null,
): React.ReactElement => {
  const [currentScrollPosition, setCurrentScrollPosition] = useState(0);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const lastestProjectReviewCard = document.getElementById(
        'lastestProjectReviewCard',
      );
      if (lastestProjectReviewCard) {
        const lastestProjectReviewCardBottom =
          lastestProjectReviewCard.offsetTop +
          lastestProjectReviewCard.offsetHeight;
        const currentPosition = window.scrollY + window.innerHeight;
        const footer: HTMLElement = document.querySelector(
          'div[data-test="footer"]',
        );
        const footerPosition = footer.offsetTop;
        if (currentPosition !== currentScrollPosition) {
          setCurrentScrollPosition(currentPosition);
          setSticky(
            window.scrollY - lastestProjectReviewCard.offsetHeight >
              lastestProjectReviewCardBottom &&
              currentPosition < footerPosition,
          );
        }
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentScrollPosition]);

  const { title, link } = props;

  if (!props || !title) return null;

  return (
    <LatestProjectReviewFooterContainer
      aria-describedby={sticky ? 'sticky' : 'normal'}
    >
      <LatestProjectReviewFooter>
        <LatestProjectReviewDetail>
          <LatestProjectReviewTitle>รีวิวโครงการ</LatestProjectReviewTitle>
          <LatestProjectReviewDescription>
            {title}
          </LatestProjectReviewDescription>
        </LatestProjectReviewDetail>
        <LatestProjectReviewButton href={link}>
          อ่านรีวิวล่าสุด
        </LatestProjectReviewButton>
      </LatestProjectReviewFooter>
    </LatestProjectReviewFooterContainer>
  );
};
